import { render, staticRenderFns } from "./viewAsignacion.vue?vue&type=template&id=50114e66"
import script from "./viewAsignacion.vue?vue&type=script&lang=js"
export * from "./viewAsignacion.vue?vue&type=script&lang=js"
import style0 from "./viewAsignacion.vue?vue&type=style&index=0&id=50114e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports